import { format } from 'date-fns'
import './intro-lesson-tool-tip.css'
const IntroLessonToolTip = ({introLessonInfo}) => {
    return (
        <div className='intro-lesson-tool-tip__wrapper'>
            <div>{introLessonInfo.teacherName}</div>
            <div>{format(new Date(introLessonInfo.dateTime), 'MMM dd')} @ {introLessonInfo.time && introLessonInfo.time}</div>
        </div>
    )
}
export default IntroLessonToolTip